import React from 'react';
import { IntroSection, FeatureGridSection } from '../components/sections';
import { FeatureCard } from '../components/cards';

export function AboutPage() {
  return (
    <>
      <IntroSection
        title="About (placeholder)"
        body="This is a secondary page in the TwentyTwentysix redesign. Compose it from the same reusable sections and cards."
      />
      <FeatureGridSection title="Features" alt>
        <FeatureCard title="Reusable" description="Build pages from shared components." />
        <FeatureCard title="Themed" description="Consistent tokens and styling." />
        <FeatureCard title="Isolated" description="Safe preview without affecting production." />
      </FeatureGridSection>
    </>
  );
}

export default AboutPage;
